var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { subtitle: "Manage time series tags across the system." },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Time Series Tags", search: "Time Series Tags" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "success" },
              on: {
                click: function ($event) {
                  _vm.showAddType = true
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("Button.Add_a_new_Tag")) + "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.tagList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "td",
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v(_vm._s(props.item.IconPath)),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.TagName) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.IconPath))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { depressed: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickEditTag(props.item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Button.Manage_Tag")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          model: {
            value: _vm.showAddType,
            callback: function ($$v) {
              _vm.showAddType = $$v
            },
            expression: "showAddType",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("AdministrationTimeSeriesTagManage.addTitleMsg")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showAddType = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tag Name",
                                  rules: _vm.tagNameRules,
                                },
                                model: {
                                  value: _vm.newTag.TagName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newTag, "TagName", $$v)
                                  },
                                  expression: "newTag.TagName",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Icon Path",
                                  items: _vm.iconList,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-content", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.newTag.IconPath,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newTag, "IconPath", $$v)
                                  },
                                  expression: "newTag.IconPath",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.addTag()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showUpdateType,
            callback: function ($$v) {
              _vm.showUpdateType = $$v
            },
            expression: "showUpdateType",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("AdministrationTimeSeriesTagManage.editTitleMsg")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showUpdateType = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form2",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid2,
                    callback: function ($$v) {
                      _vm.valid2 = $$v
                    },
                    expression: "valid2",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tag Name",
                                  rules: _vm.editTagNameRules,
                                },
                                model: {
                                  value: _vm.editTag.TagName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editTag, "TagName", $$v)
                                  },
                                  expression: "editTag.TagName",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Icon Path",
                                  items: _vm.iconList,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-content", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.editTag.IconPath,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editTag, "IconPath", $$v)
                                  },
                                  expression: "editTag.IconPath",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.updateTag()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticClass: "snackbarAdjust",
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }